import classnames from "classnames";
import * as React from "react";

import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";

import {Text} from "../components";

type ClassNames = "container" | "selected" | "text" | "textSelected";

const radius = 25;
const styles = (theme: Theme): StyleRules<ClassNames> => ({
  container: {
    marginLeft: theme.spacing.unit,
    width: radius * 2,
    height: radius * 2,
    borderRadius: radius,
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderColor: theme.palette.primary[500],
    borderStyle: "solid",
    borderWidth: 1,
    cursor: "pointer"
  },
  selected: {
    backgroundColor: theme.palette.primary[500]
  },
  text: {
    color: theme.palette.primary[500]
  },
  textSelected: {
    color: "white"
  }
});

interface ICoffeesProps extends WithStyles<typeof styles>  {
  selection: number;
  isSelected: boolean;
  onChange: (selection: string) => void;
}

class Coffees extends React.PureComponent<ICoffeesProps> {

  public onChange = () => this.props.onChange(`${this.props.selection}`);

  public render() {
    const {selection, isSelected, classes} = this.props;
    return (
      <div
        className={classnames(isSelected && classes.selected, classes.container)}
        onClick={this.onChange}
      >
        <Text
          className={isSelected ? classes.textSelected : classes.text}
          gutterBottom={false}
        >
        {`${selection}`}
        </Text>
      </div>
    );
  }
}

export default withStyles(styles)(Coffees);


// WEBPACK FOOTER //
// ./src/buy-me-a-coffee/Coffees.tsx